import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { async } from 'rxjs/internal/scheduler/async';
import { catchError, map } from 'rxjs/operators';
import { ExcelService } from '../../service/excel.service';
import { ScoreCardService } from '../../service/score-card.service';

@Component({
  selector: 'app-process-download-files',
  templateUrl: './process-download-files.component.html',
  styleUrls: ['./process-download-files.component.scss']
})
export class ProcessDownloadFilesComponent implements OnInit {

  width = 0;
  part = 100;
  value = ''
  index = 0;
  widthCss = '0%';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogRef: MatDialogRef<ProcessDownloadFilesComponent>,
    private scorecardService: ScoreCardService,
    private saveExcelFile: ExcelService,
    private cd: ChangeDetectorRef,
    private toastr: ToastrService
  ) {
    this.part = 100 / this.data.phase;
    this.value = (this.index + 1) + '/' + this.data.phase;
  }

  async ngOnInit() {
    for (let i = 0; i < this.data.phase; i++) {
      const result = await this.scorecardService.downloadInternalRawData(i, this.data.model).pipe(catchError(err => {
        this.toastr.error('An unexpected error has occurred while downloading the raw data. Please try again at a later time');
        return of({} as ArrayBuffer);
      })).toPromise();
      if (result.byteLength) {
        let fileName = 'RawData_'+ (i + 1);
        fileName = fileName.replace(/[&\/\\#,+()$~%.'":*?<>{}\s]/g, '');
        this.saveExcelFile.saveAsExcelFile(result, fileName);
        this.width += this.part;
        this.widthCss = this.width + '%';
        this.value = (i + 1) + '/' + this.data.phase;
      } else {
        this.dialogRef.close();
        return;
      }
    }
    setTimeout(() => {
      this.dialogRef.close();
    }, 1000);
  }

}
